<template>
  <div
    @click="$emit('click')"
    :style="customStyle"
    :class="{
      select: select,
      disabled: disabled,
    }"
    class="btn-color"
  >
    <!-- <span v-if="!disabled" class="sold-out">
      Sold Out
    </span> -->
    <v-icon v-if="isShowCancelIcon" color="red">
      mdi-cancel
    </v-icon>
  </div>
</template>

<script>
export default {
  computed: {
    // customClass() {
    //   if (this.disabled) {
    //     return 'btn-color disabled'
    //   } else if (this.select) {
    //     return 'btn-color select'
    //   }
    //   return 'btn-color'
    // },
    customStyle() {
      return {
        backgroundColor:
          this.color.indexOf(`#`) > -1
            ? this.color
            : `#${this.color}`,
        height: `${this.height}px`,
        width: `${this.width}px`,
      }
    },
  },

  props: {
    color: {
      type: String,
      default: '',
    },
    height: {
      type: Number,
      default: 40,
    },
    width: {
      type: Number,
      default: 40,
    },
    select: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isShowCancelIcon: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="stylus" scoped>

.btn-color
  border-radius: 50px
  border: 3.5px solid white;
  display: flex
  align-items: center
  justify-content: center
  box-shadow: inset 0 2px 3px 1px rgba(0,0,0,0.1), 0 0 2px 1.5px white;
  transition: all 0.2s ease-in-out;
  @media small
     margin: 0 auto;
  @media (hover: hover) and (pointer: fine)
    &:hover:not(.disabled)
      //border-color: transparent;
      box-shadow: 0 0 0 2px $color-bnn-border;
      cursor: pointer
      transition: all 0.2s ease-in-out;
.btn-color.select
     // outline: 1.5px solid ;
     // outline-offset: 4px;
     // box-shadow: 0 0 2px 1.5px $color-bnn-border-2;
     box-shadow: 0 0 0 1.5px $color-border-btn-spec;
     border: 3.5px solid #FFF;

.btn-color.disabled
     @media (hover: hover) and (pointer: fine)
       &:hover
         //border-color: transparent;
         box-shadow: 0 0 0 2px $color-bnn-gray-light;
         transition: 0.2s ease-in-out;
     .sold-out
        color: red
        font-weight: bold
        font-size: 0.6rem
        text-shadow: 0 0 2px #fff;
</style>
